import React from 'react';
import {IClientModel} from '../../../../src/@interfaces/models/Client/IClientModel';
import {Props} from '../../../../src/components/Form/FormField';
import ClientOrdersList from './ClientOrdersList';

export default function OrdersLoader<Model extends IClientModel = IClientModel>(props: Props<Model>) {
    if (!props.model?.id) {
        return null;
    }

    return <ClientOrdersList clientId={props.model.id} controllerName="Orders" isIsolatedComponent/>;
}
